import * as Sentry from "@sentry/react";
import React from "react";

interface Props {
  children: React.ReactNode;
  fallback?: React.ComponentType;
  showDialog?: boolean;
}

const DefaultFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="text-center">
      <div className="mb-4">
        <svg
          className="mx-auto h-12 w-12 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.996-.833-2.464 0L3.34 16.5c-.77.833.192 2.5 1.732 2.5z"
          />
        </svg>
      </div>
      <h1 className="text-xl font-semibold text-gray-900 mb-2">
        문제가 발생했습니다
      </h1>
      <p className="text-gray-600 mb-4">
        예상치 못한 오류가 발생했습니다. 잠시 후 다시 시도해주세요.
      </p>
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors"
        onClick={() => window.location.reload()}
      >
        페이지 새로고침
      </button>
    </div>
  </div>
);

export const SentryErrorBoundary: React.FC<Props> = ({
  children,
  fallback: Fallback = DefaultFallback,
  showDialog = false,
}) => {
  return (
    <Sentry.ErrorBoundary
      fallback={<Fallback />}
      showDialog={showDialog}
      beforeCapture={(scope) => {
        scope.setTag("errorBoundary", "SentryErrorBoundary");
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default SentryErrorBoundary;
